import { render } from "./TeachersTable.vue?vue&type=template&id=9cc5bc64"
import script from "./TeachersTable.vue?vue&type=script&lang=js"
export * from "./TeachersTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vncsalencar/Personal/Projects/araruna-anare-rollcall/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__